import React, { createRef, useEffect, useState } from 'react';
import {
  Col,
  Row,
  Form,
  Space,
  Button,
  message,
  Input,
  Select,
  Card,
  Upload,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { CreateRequest, getEmployees, uploadFile } from '../Api/ApiCalls';
import { UploadOutlined } from '@ant-design/icons';

import qs from 'qs';

const DeleteRequestForm = () => {
  const { Option } = Select;
  const navigate = useNavigate();
  const [fileList, setFileList] = useState();

  const [search, setSearch] = useState('');
  const formRef = createRef();
  const [employees, setEmployees] = useState();
  const { success } = message;
  const [scroll, setScroll] = useState({
    page: 1,
    size: 20,
  });

  const query = qs.stringify(
    {
      filters: {
        Name: {
          $contains: search,
        },
      },
      pagination: {
        page: scroll.page,
        pageSize: scroll.size,
      },
    },
    {
      encodeValuesOnly: true, // prettify URL
    }
  );

  useEffect(() => {
    const fetchData = async () => {
      const data = await getEmployees(query);
      setEmployees(data);
    };
    fetchData();
  }, [setEmployees, query]);

  const customRequest = ({ file, onSuccess }) => {
    const formData = new FormData();
    formData.append('files', file);
    setFileList(formData);
    onSuccess();
  };
  const onFinish = async (values) => {
    formRef.current?.resetFields();
    const randomNumber = Math.floor(1000 + Math.random() * 9000);
    values.orderNumber = `#${randomNumber}`;
    formRef.current?.resetFields();
    const image = await uploadFile(fileList);
    if (image) {
      values.Upload = image;
      const data = { data: values };
      await CreateRequest(data);
      success('تم الطلب بنجاح');
    }
  };

  const total = employees?.meta?.pagination.total;

  const handlePopupScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;

    if (bottom) {
      setScroll({
        page: scroll.size === scroll.size + 10 ? scroll.page + 1 : scroll.page,
        size: total > scroll.size ? scroll.size + 10 : scroll.size,
      });
    }
  };

  return (
    <>
      <h1
        style={{
          textAlign: 'center',
          position: 'relative',
          top: '50px',
          fontSize: '40px',
        }}
      >
        طلب اسقاط العهدة
      </h1>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          position: 'relative',
          top: '50px',
        }}
      >
        <Button size='large' onClick={() => navigate('/')}>
          الرجوع
        </Button>
      </div>
      <Form
        name='basic'
        ref={formRef}
        layout={'vertical'}
        initialValues={{ remember: false }}
        onFinish={onFinish}
        autoComplete='off'
        resetFields
      >
        <Card
          style={{
            width: '80%',
            margin: 'auto',
            top: '5rem',
            position: 'relative',
          }}
        >
          <Space direction='vertical' size='middle' style={{ display: 'flex' }}>
            <Row gutter={16}>
              <Col className='gutter-row' span={24} md={{ span: 12 }}>
                <Form.Item
                  label='رقم العهدة'
                  name='SerialNumber'
                  rules={[
                    { required: true, message: 'SerialNumber is Required!' },
                  ]}
                >
                  <Input
                    style={{ marginBottom: '10px' }}
                    placeholder='ادخل البيانات'
                  />
                </Form.Item>
              </Col>
              <Col className='gutter-row' span={24} md={{ span: 12 }}>
                <Form.Item
                  label='الموظف'
                  name='employee'
                  rules={[{ required: true, message: 'Employee is Required!' }]}
                >
                  <Select
                    style={{ marginBottom: '10px', display: 'block' }}
                    showSearch
                    placeholder='اختر موظف'
                    optionFilterProp='children'
                    onPopupScroll={handlePopupScroll}
                    onSearch={(value) => setSearch(value)}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {!employees ? (
                      <>loading...</>
                    ) : (
                      employees.data?.map((data) => {
                        return (
                          <Option key={data.id} value={data.id}>
                            {data.attributes.Name}
                          </Option>
                        );
                      })
                    )}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col className='gutter-row' span={24} md={{ span: 12 }}>
                <Form.Item
                  label='البريد الالكتروني'
                  name='email'
                  rules={[{ required: true, message: 'email is Required!' }]}
                >
                  <Input
                    style={{ marginBottom: '10px' }}
                    placeholder='ادخل البيانات'
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col className='gutter-row' span={24} md={{ span: 12 }}>
                <Form.Item
                  label='سبب الاسقاط'
                  name='Reason'
                  rules={[
                    { required: true, message: 'SerialNumber is Required!' },
                  ]}
                >
                  <Input
                    style={{ marginBottom: '10px' }}
                    placeholder='ادخل البيانات'
                  />
                </Form.Item>
              </Col>
            </Row>
            <div style={{ textAlign: 'center' }}>
              <Form.Item name={'Upload'} style={{ textAlign: 'center' }}>
                <p>تحميل صورة الطلب الورقي</p>
                <Upload
                  multiple={false}
                  customRequest={customRequest}
                  listType='picture'
                >
                  <Button size='large' icon={<UploadOutlined />}>
                    Upload
                  </Button>
                </Upload>
              </Form.Item>
            </div>
            <div style={{ textAlign: 'center' }}>
              <Button
                style={{ borderRadius: '5px', width: '150px' }}
                type='primary'
                htmlType='submit'
                size={'large'}
              >
                طلب
              </Button>
            </div>
          </Space>
        </Card>
      </Form>
    </>
  );
};

export default DeleteRequestForm;
